module.exports = __webpack_public_path__ + "static/media/phone.faf10a6c.png";